module.exports = __webpack_public_path__ + "img/inapp.a12fdb7c.jpg";